// After full vue 3 drop this file
// and use regular useRouter and useRoute
import { getCurrentInstance } from 'vue';
import type { Router, RouteLocationNormalizedLoaded } from 'vue-router';

export function useRouter(): Router {
  const vm = getCurrentInstance()!;
  return (vm.proxy as any).$router as Router;
}

export function useRoute(): RouteLocationNormalizedLoaded {
  const vm = getCurrentInstance()!;
  return (vm.proxy as any).$route as RouteLocationNormalizedLoaded;
}
